import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { API } from "@/App";
import logger from "@/utils/logger";
import { toast } from "sonner";
import adminApi from "./adminApi";
import {
  LayoutDashboard,
  Calendar,
  CalendarOff,
  Mail,
  Image,
  Star,
  Package,
  UtensilsCrossed,
  LogOut,
} from "lucide-react";

const menuItems = [
  { path: "/admin/dashboard", icon: LayoutDashboard, labelKey: "admin.dashboard.title" },
  { path: "/admin/dashboard/bookings", icon: Calendar, labelKey: "admin.dashboard.bookings" },
  { path: "/admin/dashboard/availability", icon: CalendarOff, labelKey: "admin.dashboard.availability" },
  { path: "/admin/dashboard/inquiries", icon: Mail, labelKey: "admin.dashboard.inquiries" },
  { path: "/admin/dashboard/packages", icon: Package, labelKey: "admin.dashboard.packages" },
  { path: "/admin/dashboard/menu-items", icon: UtensilsCrossed, label: "Menu Items" },
  { path: "/admin/dashboard/gallery", icon: Image, labelKey: "admin.dashboard.gallery" },
  { path: "/admin/dashboard/testimonials", icon: Star, labelKey: "admin.dashboard.testimonials" },
];

const Sidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const adminName = sessionStorage.getItem("adminName") || "Admin";

  const handleLogout = async () => {
    try {
      await adminApi.post(`${API}/admin/logout`);
    } catch (error) {
      logger.error("Logout request failed:", error);
    }
    sessionStorage.removeItem("adminName");
    sessionStorage.removeItem("adminEmail");
    sessionStorage.removeItem("adminLoggedIn");
    toast.success(t("admin.dashboard.logoutSuccess"));
    navigate("/admin");
  };

  return (
    <aside className="admin-sidebar fixed left-0 top-0 h-screen w-64 flex flex-col" data-testid="admin-sidebar">
      <div className="flex items-center gap-2 mb-10">
        <img src="/logo.svg" alt="Djohomi Foods" className="w-10 h-10 object-contain" />
        <span className="text-xl font-bold font-['Playfair_Display']">Djohomi Foods</span>
      </div>
      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            data-testid={`sidebar-${item.path.split("/").pop()}`}
            className={`admin-sidebar-link ${location.pathname === item.path ? "active" : ""}`}
          >
            <item.icon className="w-5 h-5" />
            {item.labelKey ? t(item.labelKey) : item.label}
          </Link>
        ))}
      </nav>
      <div className="border-t border-white/10 pt-4 mt-4">
        <div className="px-4 py-2 mb-2">
          <p className="text-sm text-white/60">{t("admin.dashboard.loggedInAs")}</p>
          <p className="font-medium truncate">{adminName}</p>
        </div>
        <button
          onClick={handleLogout}
          data-testid="logout-btn"
          className="admin-sidebar-link w-full text-left hover:bg-red-500/20"
        >
          <LogOut className="w-5 h-5" />
          {t("admin.dashboard.logout")}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
